module.exports = __webpack_public_path__ + "img/reserve.ea98dd1f.png";